import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="font-heading text-xl font-bold text-background-50 hover:text-accent-400 transition-colors duration-300">
                岛国精品
              </Link>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                {t('siteSlogan')}。汇聚日本美妆护肤、食品零食、家居日用等多品类精选好物。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-all duration-300" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-all duration-300" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-all duration-300" aria-label="小红书">
                  <i className="ri-chat-smile-2-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">{t('navHome')}</Link></li>
                <li><Link to="/category" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">{t('navCategory')}</Link></li>
                <li><Link to="/articles" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">{t('navArticles')}</Link></li>
                <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">{t('navAbout')}</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category?tab=beauty" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">美妆护肤</Link></li>
                <li><Link to="/category?tab=food" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">食品零食</Link></li>
                <li><Link to="/category?tab=home" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">家居日用</Link></li>
                <li><Link to="/category?tab=health" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200">健康保健</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-background-300">
                  <i className="ri-phone-line mt-0.5 text-background-400"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-300">
                  <i className="ri-mail-line mt-0.5 text-background-400"></i>
                  <span>service@daoguojingpin.com</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-300">
                  <i className="ri-map-pin-line mt-0.5 text-background-400"></i>
                  <span>上海市浦东新区陆家嘴世纪大道100号</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-300">
                  <i className="ri-time-line mt-0.5 text-background-400"></i>
                  <span>周一至周五 9:00 - 18:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              © {currentYear} 岛国精品（上海）国际贸易有限公司 {t('footerRights').replace('© 2026 ', '')}
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200">{t('footerPrivacy')}</a>
              <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200">{t('footerTerms')}</a>
              <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors duration-200">{t('footerSitemap')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}